<template>
  <div class="account-setting">
    <div class="Lists">
      <div
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
        "
      >
        <h4>直营合作伙伴</h4>
        <van-icon name="add-o" size="20" @click="onSubmit" />
        <!-- <van-button

          type="primary"
          size="large"
          round
          color="#1c86dc"
          style="
            width: 60%;
            font-size: 1rem;
            margin: 1rem 0;
            color: white;
            background: rgb(28, 134, 220);
            border-color: rgb(28, 134, 220);
          "
          @click="onSubmit"
          >添加</van-button
        > -->
      </div>
      <van-cell-group
        :border="false"
        v-if="List != null && List.length != 0 ? true : false"
      >
        <van-cell
          :title="items.fullName"
          v-for="(items, index) in List"
          :key="index"
        >
          <template #right-icon>
            <van-icon
              :name="require('@/assets/delivery/list.png')"
              style="font-size: 1.3rem"
              @click="onSubmits(items)"
            />
          </template>
        </van-cell>
      </van-cell-group>
      <div v-else>
        <van-empty description="此账号无直营合作伙伴" />
      </div>
    </div>
    <van-divider />
    <div class="Lists">
      <div>
        <h4>省内合作伙伴</h4>
      </div>
      <van-cell-group
        :border="false"
        v-if="proxies != null && proxies.length != 0 ? true : false"
      >
        <van-cell
          :title="items.fullName"
          v-for="(items, index) in proxies"
          :key="index"
        >
        </van-cell>
      </van-cell-group>
      <div v-else>
        <van-empty description="此账号无省内合作伙伴" />
      </div>
    </div>
  </div>
</template>

<script>
import { child } from "@/api/subordinate";

export default {
  data() {
    return {
      List: [],
      proxies: [],
    };
  },
  mounted() {
    this.gainShop();
  },
  methods: {
    gainShop() {
      child()
        .then((res) => {
          res.result.map((item) => {
            if (item.directProxy) {
              this.proxies.push(item);
            } else {
              this.List.push(item);
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onSubmit() {
      this.$router.push({
        name: "storestheditor",
      });
    },
    onSubmits(data) {
      this.$router.push({
        name: "storestheditor",
        query: {
          items: data,
          type: true,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.account-setting {
  .Lists {
    width: 85%;
    margin: 0 auto;
    text-align: initial;
    margin-top: 1rem;
  }
}
</style>
